module.exports = __webpack_public_path__ + "static/media/review2_guide.f0ecf3e2.png";